import {IFeature, IFreemiumBanner} from '@dazn/lp-web/src/types';
import {getImage} from '@dazn/lp-web/src/utils';
import {buttonProxy} from '@dazn/lp-web/src/proxies/button.proxy';
import {STATIC_IMAGE_URL} from '@dazn/lp-web/src/types/common.types';

export function freemiumBannerProxy(component: any): IFreemiumBanner {
    const componentType = component?.fields?.componentType;
    const banner =
        component?.fields?.entries?.map((entry: any) => {
            const {
                title,
                description,
                badgeText,
                showBadge,
                backgroundImage,
                buttons,
                features = []
            } = entry?.fields ?? {};
            return {
                title,
                description,
                badgeText,
                showBadge,
                image: getImage(backgroundImage),
                button: buttonProxy(buttons[0]?.fields),
                features: features?.map(({fields}: {fields: IFeature}) => {
                    return {
                        ...fields,
                        iconUrl: fields?.key
                            ? STATIC_IMAGE_URL + fields.key + '.png'
                            : ''
                    };
                })
            };
        })?.[0] ?? {};
    return {
        componentType,
        banner
    };
}
